import { render, staticRenderFns } from "./ConfigurationAction.vue?vue&type=template&id=4a648bf1&scoped=true&"
import script from "./ConfigurationAction.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a648bf1",
  null
  
)

export default component.exports